import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { nonBotUsers } from 'app/modules/user/selectors'
import { AsyncButton, Table, TextLoader, ToolTip } from '@driftt/tide-core-legacy'
import { getMicrosoftAdminConsentUsers,
         isMicrosoftGlobalCalendarsLoaded,
         isMicrosoftGlobalCalendarsLoading } from 'app/modules/meetings/selectors'
import { fetchMicrosoftManagedCalendars, disconnectMicrosoftAdminConsent } from 'app/modules/meetings/actions'

import outlookSrc from 'images/logos/office-365.svg'
import magnifyingGlassSVG from 'images/svg/magnifying-glass.svg'

import './style.styl'

const REFRESH_TOOLTIP = <div>If new email accounts are <br/> added after you initially <br/> connected, refresh to add <br/> them to the list.</div>

class GlobalConnectedCalendars extends PureComponent {

  state = {
    calendarUsers: []
  }

  async componentDidMount() {
    await this.props.actions.fetchMicrosoftManagedCalendars()
  }

  componentDidUpdate(prevProps) {
    if(prevProps.globalCalendarUserIds !== this.props.globalCalendarUserIds) {
      this.mapUsers()
    }
  }

  mapUsers = () => {
    const { orgUsers, globalCalendarUserIds } = this.props
    const users = globalCalendarUserIds.map(userId => orgUsers[userId])
    this.setState({ calendarUsers: users })
  }

  onDisconnectClicked =  async () => {
    const { actions, onDisconnect } = this.props
    return Promise.all([
      await actions.disconnectMicrosoftAdminConsent(),
      await onDisconnect()
    ])
  }

  onRefreshClicked = async () => {
   return await this.props.actions.fetchMicrosoftManagedCalendars()
  }

  createTableColumns = () => ([
    { label: 'NAME', width: '40%' },
    { label: 'EMAIL', width: '60%' }
  ])

  createTableRow = user => ({
    className: `connected-calendar-table-row`,
    data: [
      { content: <span>{user.name}</span> },
      { content: <span>{user.email}</span> },
    ]
  })

  renderTable = (users) => (
    <div className="settings-global-calendar--calendar-table-content">
      <Table
        className="settings-global-calendar-table"
        columns={this.createTableColumns()}
        data={users.map(this.createTableRow)}
      />
      { users && !users.length &&
        <div className="settings-global-calendar--calendar-table-empty">
          <img src={magnifyingGlassSVG}/>
          <p> Hmmm... there’s nothing here <br/> Once you have users in your Microsoft domain, refresh and they should appear here! </p>
        </div>
      }
    </div>
  )

  render() {
    const { calendarUsers } = this.state
    const { isLoadingUsers, hasLoadedUsers } = this.props

    return (
      <div className="settings-global-calendar--calendar-table">
        <div className="settings-global-calendar--calendar-content">
          <div className="settings-global-calendar--calendar-header">
            <img src={outlookSrc}/>
            <div className="settings-global-calendar--calendar-header-description">
              <h2>Connected Calendars</h2>
              <p>We’ll use these calendars to check for any conflicts when new meetings are being scheduled, add new calendar events to them</p>
            </div>
            <div className="settings-global-calendar--calendar-header-button-container">
              <ToolTip flow="up" component={REFRESH_TOOLTIP}>
                <AsyncButton icon="refresh-2" iconAlignment="left" type="tertiary" promise={this.onRefreshClicked}>Refresh Accounts</AsyncButton>
              </ToolTip>
              <AsyncButton type="danger" onClick={this.onDisconnectClicked}>Disconnect All</AsyncButton>
            </div>
          </div>
          { isLoadingUsers && <TextLoader className="settings-global-calendar--loader" text="Fetching your calendars..." size={250}/> }
          { hasLoadedUsers && this.renderTable(calendarUsers) }
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchMicrosoftManagedCalendars,
      disconnectMicrosoftAdminConsent
    },
    dispatch
  ),
})

const mapStateToProps = state => ({
  globalCalendarUserIds: getMicrosoftAdminConsentUsers(state),
  isLoadingUsers: isMicrosoftGlobalCalendarsLoading(state),
  hasLoadedUsers: isMicrosoftGlobalCalendarsLoaded(state),
  orgUsers: nonBotUsers(state).toJS(),
})

export default connect(mapStateToProps, mapDispatchToProps)(GlobalConnectedCalendars)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/GlobalCalendarSettings/ConnectedCalendars/index.js